import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { FormProvider, RHFTextField } from "../components/hook-form";
import { Link, useNavigate } from "react-router-dom";
import {
  initiateAuth,
  login,
  loginUser,
  registerUser,
} from "../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../components/Spinner";
import qs from "qs";

import { useTranslation } from "react-i18next";
import { Menu } from "@mui/material";

const Register = () => {
  const { t } = useTranslation();
  const registerSchema = Yup.object().shape({
    password: Yup.string()
      .required()

      .min(6)
      .max(12),
    email: Yup.string().required(),
    firstName: Yup.string().required(),
    lastName: Yup.string().required(),
    confirmPassword: Yup.string()
      .required("password is a required field")
      .oneOf([Yup.ref("password")], "password does not match"),
  });

  const defaultValues = {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    confirmPassword: "",

    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(registerSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, loading, error } = useSelector((state) => state.Auth);
  const onSubmit = async (values) => {
    // RegisterUser(values);
    console.log(values);
    dispatch(registerUser(values));
  };

  useEffect(() => {
    if (user?.token) navigate("/", { replace: true });
  }, [user, navigate]);

  const responseFacebook = (response) => {
    console.log(response);
  };

  const componentClicked = (data) => {
    console.warn(data);
  };
  return (
    <div className=" min-h-screen rounded-sm ">
      <svg
        className="hidden"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320">
        <path
          fill="hsl(356, 77%, 50%)"
          fill-opacity="0.3"
          d="M0,96L6.3,101.3C12.6,107,25,117,38,144C50.5,171,63,213,76,202.7C88.4,192,101,128,114,96C126.3,64,139,64,152,96C164.2,128,177,192,189,181.3C202.1,171,215,85,227,53.3C240,21,253,43,265,42.7C277.9,43,291,21,303,53.3C315.8,85,328,171,341,186.7C353.7,203,366,149,379,149.3C391.6,149,404,203,417,224C429.5,245,442,235,455,213.3C467.4,192,480,160,493,170.7C505.3,181,518,235,531,240C543.2,245,556,203,568,165.3C581.1,128,594,96,606,74.7C618.9,53,632,43,644,48C656.8,53,669,75,682,117.3C694.7,160,707,224,720,218.7C732.6,213,745,139,758,106.7C770.5,75,783,85,796,122.7C808.4,160,821,224,834,250.7C846.3,277,859,267,872,234.7C884.2,203,897,149,909,117.3C922.1,85,935,75,947,101.3C960,128,973,192,985,213.3C997.9,235,1011,213,1023,197.3C1035.8,181,1048,171,1061,144C1073.7,117,1086,75,1099,58.7C1111.6,43,1124,53,1137,90.7C1149.5,128,1162,192,1175,186.7C1187.4,181,1200,107,1213,85.3C1225.3,64,1238,96,1251,128C1263.2,160,1276,192,1288,181.3C1301.1,171,1314,117,1326,96C1338.9,75,1352,85,1364,106.7C1376.8,128,1389,160,1402,154.7C1414.7,149,1427,107,1434,85.3L1440,64L1440,0L1433.7,0C1427.4,0,1415,0,1402,0C1389.5,0,1377,0,1364,0C1351.6,0,1339,0,1326,0C1313.7,0,1301,0,1288,0C1275.8,0,1263,0,1251,0C1237.9,0,1225,0,1213,0C1200,0,1187,0,1175,0C1162.1,0,1149,0,1137,0C1124.2,0,1112,0,1099,0C1086.3,0,1074,0,1061,0C1048.4,0,1036,0,1023,0C1010.5,0,998,0,985,0C972.6,0,960,0,947,0C934.7,0,922,0,909,0C896.8,0,884,0,872,0C858.9,0,846,0,834,0C821.1,0,808,0,796,0C783.2,0,771,0,758,0C745.3,0,733,0,720,0C707.4,0,695,0,682,0C669.5,0,657,0,644,0C631.6,0,619,0,606,0C593.7,0,581,0,568,0C555.8,0,543,0,531,0C517.9,0,505,0,493,0C480,0,467,0,455,0C442.1,0,429,0,417,0C404.2,0,392,0,379,0C366.3,0,354,0,341,0C328.4,0,316,0,303,0C290.5,0,278,0,265,0C252.6,0,240,0,227,0C214.7,0,202,0,189,0C176.8,0,164,0,152,0C138.9,0,126,0,114,0C101.1,0,88,0,76,0C63.2,0,51,0,38,0C25.3,0,13,0,6,0L0,0Z"></path>
      </svg>

      <div className="w-full text-center  flex justify-center items-center flex-col-reverse md:flex-row grid-cols-12 min-h-screen ">
        <div className="flex-[.7]">
          <img
            src="/lover.jpg"
            className="w-full flex-[.6] animate-pulse col-span-12  md:col-span-7"
            alt=""
          />
        </div>
        <div
          className="flex-[.4] col-span-12 mx-[2rem] md:col-span-5"
          style={{
            backgroundImage: "url(/lllove.svg)",
            backgroundSize: "contain",
            backgroundPosition: "top",
            backgroundRepeat: "no-repeat",
          }}>
          <h2
            style={{ fontFamily: "'Kaushan Script', cursive " }}
            className="text-6xl mb-10 text-pink-400 text-center">
            welcome to heartlink
          </h2>
          <FormProvider
            methods={methods}
            classes=" shadow-lg border-slate-100 rounded-lg p-6 mt-4 mx-4  bg-white"
            onSubmit={handleSubmit(onSubmit)}
            // style={{background: "url(/lllove.svg)"}}
          >
            <p className="text-pink-900 text-center">
              {typeof error === "string" ? error : error?.errors[0].msg}
            </p>
            {/* <p className="text-pink-900 text-center">{msg}</p> */}
            <RHFTextField
              type="text"
              label={t("first name")}
              placeholder="please enter your first name"
              name="firstName"
              classes="bg-pink-50"
            />
            <RHFTextField
              type="text"
              label={t("last name")}
              placeholder="please enter your last name"
              name="lastName"
              classes="bg-pink-50"
            />
            <RHFTextField
              type="email"
              label={t("email")}
              placeholder="please enter your email"
              name="email"
              classes="bg-pink-50"
            />
            <RHFTextField
              type="password"
              label={t("password")}
              placeholder="please enter your password"
              name="password"
              classes="bg-pink-50"
              autocomplete="new-password"
            />

            <RHFTextField
              type="password"
              label={t("Confirm password")}
              placeholder="renter your password"
              name="confirmPassword"
              classes="bg-pink-50"
              autocomplete="new-password"
            />

            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-pink-600 text-white rounded shadow w-full p-2 mb-2 mt-4"
                // disabled={loading}
              >
                <Spinner loading={loading} text={t("register")} />
              </button>
            </div>
            <Link to="/auth/login" className="text-pink-400 animate-pulse">
              Sign in
            </Link>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Register;
